import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 10",
    id: "SB3-U10-P68-E1",
    audio: "img/FriendsPlus/Page68/Audio/audio-e1-p68.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        { url: "img/FriendsPlus/Page68/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page68/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/tieude-e1-p68.mp3",
        },
        { url: "img/FriendsPlus/Page68/E1/3.jpg" },
      ],
      [
        // Column2
        {
          url: "img/FriendsPlus/Page68/E1/4.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/wedding.mp3",
        },
        {
          url: "img/FriendsPlus/Page68/E1/5.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/guests.mp3",
        },
        {
          url: "img/FriendsPlus/Page68/E1/6.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/bride.mp3",
        },
        {
          url: "img/FriendsPlus/Page68/E1/7.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/band.mp3",
        },
        {
          url: "img/FriendsPlus/Page68/E1/8.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/invitation.mp3",
        },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 10",
    id: "SB3-U10-P68-E2",
    audio: "img/FriendsPlus/Page68/Audio/audio-e2-p68.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page68/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page68/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/tieude-e2-p68.mp3",
        },
        { url: "img/FriendsPlus/Page68/E2/3.jpg" },
      ],
      [
        // Column2
        {
          url: "img/FriendsPlus/Page68/E2/4.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/wedding.mp3",
        },
        {
          url: "img/FriendsPlus/Page68/E2/5.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/guests.mp3",
        },
        {
          url: "img/FriendsPlus/Page68/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/bride.mp3",
        },
        {
          url: "img/FriendsPlus/Page68/E2/7.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/band.mp3",
        },
        {
          url: "img/FriendsPlus/Page68/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page68/Audio/invitation.mp3",
        },
      ],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 10",
    id: "SB3-U10-P68-E3",
    audio: "img/FriendsPlus/Page68/Audio/audio-e3-p68.mp3",
    video: "Videos/e3.p68.mp4",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page68/E3/1.jpg" },
        { url: "img/FriendsPlus/Page68/E3/2.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/tieude-e3-p68.mp3", },
        { url: "img/FriendsPlus/Page68/E3/3.jpg" },
      ],
      [
        { url: "img/FriendsPlus/Page68/E3/4.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh1-e3-p68.mp3" },
        { url: "img/FriendsPlus/Page68/E3/5.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh2-e3-p68.mp3" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page68/E3/6.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh3-e3-p68.mp3" },
        { url: "img/FriendsPlus/Page68/E3/7.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh4-e3-p68.mp3" },
      ],
      [
        { url: "img/FriendsPlus/Page68/E3/8.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh5-e3-p68.mp3" },
        { url: "img/FriendsPlus/Page68/E3/9.jpg", audioUrl: "img/FriendsPlus/Page68/Audio/hinh6-e3-p68.mp3" },
      ],
    ],
  },
};

export default json;
